import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LineWeight } from "@mui/icons-material";

const NavMenu = ({ strings, userData }) => {
  ////console.log(strings);
  const history = useHistory();

  const resetQuerySearch = (_where) => {
    //sessionStorage.setItem("filter", JSON.stringify({}))   DA ABILITARE SE VUOLE RESETTARE TUTTI I FILTRI


    sessionStorage.setItem("filter", JSON.stringify({}))
    //setSortValues({})
    //setRefresh(!refresh)
    //history.push("/")
    //setTimeout(() => history.push(process.env.PUBLIC_URL + "/shop-grid-full-width"), 10);
    //sessionStorage.setItem("currentPage", 1)

    sessionStorage.setItem("currentPage", 1)
    setTimeout(() => history.push("/"), 50);
    setTimeout(() => history.push(process.env.PUBLIC_URL + _where), 100);

    //}
  }


  return (
    <div className="main-menu">
      <nav>
        <ul style={{ textAlign: 'left' }}>

          {!((userData?.user?.user) && (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge))
            &&
            <li>
              <Link to={process.env.PUBLIC_URL + "/login"} style={{ lineHeight: '68px' }}>
                {"Login"}
              </Link>
            </li>
          }

          <li>
            <Link onClick={() => resetQuerySearch("/shop-grid-full-width?name=")} to={process.env.PUBLIC_URL + "/shop-grid-full-width"} style={{ lineHeight: '68px' }}>
              {(userData?.user?.user?.IDCli || userData?.user?.user?.IDAge) ? 'Acquisti' : 'Prodotti'}
            </Link>
          </li>


          {((userData?.user?.user) && (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge))
            &&
            <li>
              <Link onClick={() => resetQuerySearch("/consigliati?name=")} to={process.env.PUBLIC_URL + "/consigliati"} style={{ lineHeight: '68px' }}>
                {'Consigliati'}
              </Link>
            </li>
          }

          <li>
            <Link to={process.env.PUBLIC_URL + "/CatalogFlip"} style={{ lineHeight: '68px' }}>
              {strings["catalog"]}
            </Link>
          </li>



          {((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge)) ? <li>
            {/*<img src="https://media.giphy.com/media/RKKPOi4piK6CUXiUj7/giphy.gif" style={{width:"25%", float:"left", position:"absolute", top:"17%", left:"-5%"}}></img>*/}
            <Link to={process.env.PUBLIC_URL + "/my-documents"} style={{ lineHeight: '68px' }}>I miei documenti </Link>
          </li> : null}
          {((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge)) ? <li>
            <img src="https://media.giphy.com/media/RKKPOi4piK6CUXiUj7/giphy.gif" style={{ width: "45%", float: "left", position: "absolute", top: "17%", left: "-5%" }}></img>
            <Link to={process.env.PUBLIC_URL + "/my-pricelist"} style={{ lineHeight: '68px' }}>Listino</Link>
          </li> : null}

          {(/*userData.user.user?.IDCli === 41917 && */
            userData?.user?.user?.IDCli &&
            window['configPegaso'].untentiModificaBanners?.includes(localStorage.getItem("IDDetCliRef")))
            ?
            <li>
              <Link to={process.env.PUBLIC_URL + "/personalizzaBanners"} style={{ lineHeight: '68px' }}>
                {'Banners'}
              </Link>
            </li> : null
          }

          <li>
            <Link to={process.env.PUBLIC_URL + "/about"} style={{ lineHeight: '68px' }}>
              {"Chi siamo"}
            </Link>
          </li>



          <li>
            <Link to={process.env.PUBLIC_URL + "/contact"} style={{ lineHeight: '68px' }}>
              {strings["contact_us"]}
            </Link>
          </li>

          {
            (false && <li className="hidden">
              <Link to={process.env.PUBLIC_URL + "/blog-standard"} style={{ lineHeight: '68px' }}>
                {strings["blog"]} <i className="fa fa-angle-down" />
              </Link>
              <ul className="submenu">
                <li>
                  <Link to={process.env.PUBLIC_URL + "/blog-standard"} style={{ lineHeight: '68px' }}>
                    {strings["blog_standard"]}
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/blog-no-sidebar"} style={{ lineHeight: '68px' }}>
                    {strings["blog_no_sidebar"]}
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/blog-right-sidebar"} style={{ lineHeight: '68px' }}>
                    {strings["blog_right_sidebar"]}
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/blog-details-standard"} style={{ lineHeight: '68px' }}>
                    {strings["blog_details_standard"]}
                  </Link>
                </li>
              </ul>
            </li>
            )}

        </ul>
      </nav>
    </div>
  );
};

NavMenu.propTypes = {
  strings: PropTypes.object
};

const mapStateToProps = state => {
  return {
    userData: state.userData
  };
};

//export default multilanguage(NavMenu);
//export default NavMenu;
export default connect(mapStateToProps)(NavMenu);